import React from "react";
import { Redirect } from "react-router-dom";
import RouteRegistryJson from "./views/RouteRegistryJson";
import sessionsRoutes from "./views/sessions/sessionsRoutes";
import kiosqueRoutes from "./views/kiosque/kiosqueRoutes";
import welcomeRoutes from "./views/welcome/welcomeRoutes";
import administrationRoutes from "./views/administration/administrationRoutes";
import usersRoutes from "./views/users/usersRoutes";
import posBaseRoutes from "./views/pos/posBaseRoutes";
import wmsRoutes from "./views/wms/wmsRoutes";
import rhtimeRoutes from "./views/rhtime/rhtimeRoutes";
import erpRoutes from "./views/erp/erpRoutes";
import historiqueRoutes from "./views/historique/historiqueRoutes";
import notificationsRoutes from "./views/notifications/notificationsRoutes";
import facturationRoutes from "./views/facturation/facturationRoutes";
import documentationRoutes from "./views/documentation/documentationRoutes";
import Guard from "./auth/Guard";

const redirectRoute = [
  {
    path: "/",
    exact: true,
    component: () => <Redirect to="/welcome/welcome" />
  }
];

const errorRoute = [
  {
    component: () => <Redirect to="/session/404" />
  }
];

const routes = [
  ...sessionsRoutes,
  ...kiosqueRoutes,
  {
    path: "/route-registry",
    exact: true,
    component: RouteRegistryJson
  },
  {
    path: "/",
    component: Guard,
    routes: [
      ...welcomeRoutes,
      ...administrationRoutes,
      ...erpRoutes,
      ...facturationRoutes,
      ...usersRoutes,
      ...posBaseRoutes,
      ...wmsRoutes,
      ...rhtimeRoutes,
      ...historiqueRoutes,
      ...notificationsRoutes,
      ...documentationRoutes,
      ...redirectRoute,
      ...errorRoute
    ]
  }
];

export default routes;
